import React from 'react';
import Page from './Page';
import { Redirect } from 'react-router-dom';

export default [
    <Page key='create-booking-funnel' exact path='/create_booking/:funnel?' render={ () => {
        return <Redirect to='/booking-tool' />;
    } } />,

    <Page key='crm-website' exact path='/crm_website/:id/compare' render={ () => {
        return <Redirect to='/booking-tool' />;
    } } />,

    <Page key='orders-id-amend' exact path='/orders/:id/amend' render={ (props) => {
        const { id } = props.match.params;

        if (!id) {
            return <Redirect to={ '/orders' } />;
        }

        return <Redirect to={ `/orders/${ id }/show ` } />;
    } } />,

    <Page key='orders-id-product' exact path='/orders/:id/product' render={ (props) => {
        const { id } = props.match.params;

        if (!id) {
            return <Redirect to={ '/orders' } />;
        }

        return <Redirect to={ `/orders/${ id }/show ` } />;
    } } />,

    <Page key='funnels' path='/funnels' render={ () => {
        return <Redirect to='/campaigns' />;
    } } />,

    <Page key='orders-id-show' exact path='/orders/:id/show' render={ (props) => {
        const { id } = props.match.params;

        return <Redirect to={ `/bookings/${ id }/show` } />;
    } } />,

    <Page key='orders-id-edit' exact path='/orders/:id' render={ (props) => {
        const { id } = props.match.params;

        return <Redirect to={ `/bookings/${ id }` } />;
    } } />,

    <Page key='orders-list' exact path='/orders' render={ () => {
        return <Redirect to='/bookings' />;
    } } />,

    <Page key='orders-stats' exact path='/order_stats/' render={ () => {
        return <Redirect to='/booking-stats' />;
    } } />,
];



// WEBPACK FOOTER //
// ./src/routes/deprecated.js